import React from 'react';
import { Button } from 'antd';
import StageRow from './StageRow';
import s from '../s.module.less';

type Props = {
    isGroupSubmit: boolean;
    onBack: () => void;
    onOpenEhr: () => void;
    onTrack: () => void;
};

// 另一个 offer：从确认页页脚的安静链接进来，用一次就诊的走法介绍 EHR，不列功能清单
export default function EhrScreen({ isGroupSubmit, onBack, onOpenEhr, onTrack }: Props) {
    return (
        <>
            <div className={s.backRow}>
                <Button type="link" onClick={onBack}>
                    Back
                </Button>
            </div>
            <div className={s.eyebrow}>Klarity EHR</div>
            <h1 className={s.h1}>
                {isGroupSubmit ? 'Explore before bringing your team.' : 'See how your next visit could work.'}
            </h1>
            <p className={s.lead}>A free EHR for scheduling and charting. Here is how a visit works.</p>
            <div className={`${s.card} ${s.listCard}`}>
                <StageRow num={1} title="Schedule" sub="Choose a visit type and available time." first />
                <StageRow num={2} title="Document" sub="Keep visit notes together in the patient chart." />
                <StageRow num={3} title="Follow up" sub="Plan the next visit." last />
            </div>
            <div className={s.actions}>
                <Button type="primary" onClick={onOpenEhr}>
                    Open the EHR
                </Button>
                <Button type="link" onClick={onTrack}>
                    Back to credentialing
                </Button>
            </div>
        </>
    );
}
